import * as React from 'react';
import {useContext} from 'react'
import Table from 'react-bootstrap/Table';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Alert from 'react-bootstrap/Alert';
import { postRequest } from '../../../lib/api';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import CircularProgress from '@mui/material/CircularProgress';
import { AuthContext } from '../../../authContext/context';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import BreadcrumbsWrapper from '../../../components/breadcrumbs' 
///import {useSelector , useDispatch} from 'react-redux'
//import { updateSolicitor } from '../../../redux/slices/solicitorsSlice';
//import { Helmet } from 'react-helmet-async';


export default function Edit() {

  
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
    setValue,
  } = useForm();

  const {id} = useParams()
  //const dispatch = useDispatch()

  const [loading, setLoading] = useState(false);
 
    const authCtx = useContext(AuthContext);

 React.useEffect(() => {
  const fetchSolicitorData = async () => {
    try {
      const response = await postRequest(`private/singleUser/${id}`, {}, authCtx.token);
      if (response?.status === 200) {
        const data = response?.data;

        reset({
          forename: data?.forename || '',
          surname: data?.surname || '',
          email: data?.email || '',
          username: data?.username || '',
          phone_number: data?.phone_number || '',
        });
      } else {
       // toast.error(response?.message || 'Failed to load solicitor data');
      }
    } catch (err) {
      toast.error(err?.message || 'Error loading solicitor');
    }
  };

  fetchSolicitorData();
}, [id, authCtx.token, reset]);

   

  const navigate = useNavigate()

    const onSubmit = async (data) => {
    setLoading(true);
    try {
      
      const payload = {
        forename: data?.forename,
        surname: data?.surname,
        email: data?.email,
        username: data?.username,
        phone_number: data?.phone_number,
      };

      const response = await postRequest(`private/editUser/${id}`, payload, authCtx.token);
      if (response?.status === 200) {
        //toast.success('User updated successfully!');
       //dispatch(updateSolicitor(response?.data));

        reset();
        navigate('/users');
      } else {
        //toast.error(response?.message || 'Solicitor update failed');
      }
    } catch (err) {
      //toast.error(err?.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
         {/* <Helmet>
                <title>Edit User - Universal Admin</title>
              </Helmet>
              <h1>Edit User</h1> */}

                  <BreadcrumbsWrapper
                                      items={[
                                        { label: 'Dashboard', path: '/dashboard' },
                                        { label: 'Users', path: '/users' },
                                        { label: 'Edit user', path: '' },
                                      ]}
                                    />
                              <br></br>
    
      <div className='page-header'>
        <h1 className='mt-0'>Edit User</h1>
      </div>

      <div className='page-top-formview mb-3'>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row className="mb-3">
            <Form.Group as={Col} controlId="firstName">
              <Form.Label>Forename</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter first name"
                {...register('forename', {
                  required: 'First name is required',
                  minLength: {
                    value: 2,
                    message: 'Minimum 2 characters required',
                  },
                })}
                isInvalid={!!errors.forename}
              />
              <Form.Control.Feedback type="invalid">
                {errors.forename?.message}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} controlId="surname">
              <Form.Label>Surname</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter last name"
                {...register('surname', {
                  required: 'Last name is required',
                  minLength: {
                    value: 2,
                    message: 'Minimum 2 characters required',
                  },
                })}
                isInvalid={!!errors.surname}
              />
              <Form.Control.Feedback type="invalid">
                {errors.surname?.message}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} controlId="email">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter email"
                {...register('email', {
                  required: 'Email is required',
                  pattern: {
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: 'Invalid email address',
                  },
                })}
                isInvalid={!!errors.email}
              />
              <Form.Control.Feedback type="invalid">
                {errors.email?.message}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} controlId="phone_number">
              <Form.Label>Phone Number</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter phone number"
                {...register('phone_number')}
                isInvalid={!!errors.phone_number}
              />
              <Form.Control.Feedback type="invalid">
                {errors.phone_number?.message}
              </Form.Control.Feedback>
            </Form.Group>
                    <Form.Group as={Col} controlId="username">
              <Form.Label>Username</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter username"
                {...register('username', {
                  required: 'Username is required',
                  minLength: {
                    value: 2,
                    message: 'Minimum 2 characters required',
                  },
                })}
                isInvalid={!!errors.username}
              />
              <Form.Control.Feedback type="invalid">
                {errors.username?.message}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>


          <Stack direction="row" spacing={2}>
            <Button variant="outlined" onClick={() => navigate('/users')} color="inherit" type="button" disabled={loading}>
              Cancel
            </Button>
            <Button variant="contained" className='red-bg red-button text-capitalize' type="submit" disabled={loading}>
              {loading ? <CircularProgress size={20} color="inherit" /> : 'Submit'}
            </Button>
          </Stack>
        </Form>
      </div>
    </>
  );
}